import { Link } from '@tanstack/react-router'
import { FileQuestion, ArrowLeft, Home } from 'lucide-react'
import './ErrorPages.css'

export function NotFoundPage() {
  return (
    <div className="error-page">
      <div className="error-content">
        <div className="error-icon">
          <FileQuestion size={64} />
        </div>
        <h1 className="error-code">404</h1>
        <h2 className="error-title">Page Not Found</h2>
        <p className="error-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="error-actions">
          <button className="btn btn-secondary" onClick={() => window.history.back()}>
            <ArrowLeft size={16} />
            Go Back
          </button>
          <Link to="/law/vault" className="btn btn-primary">
            <Home size={16} />
            Go to Vault
          </Link>
        </div>
      </div>
    </div>
  )
}
